<template>
  <div class="currencySettingsDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.Currency"
        :label="$t.currencySettings.currency"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.CurrencySn"
        :label="$t.currencySettings.currencySn"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.CurrencySymbol"
        :label="$t.currencySettings.currencySymbol"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "currencySettingsDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      SCId: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("currencySettingsDetail"));
      this.form = data;
    } else {
      this.form = {
        SCId: null,
        Currency: "",
        CurrencySn: "",
        CurrencySymbol: "",
      };
    }
  },
  methods: {
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      var request = null;
      if (this.isEdit) {
        request = this.$api.systemManagement.editSystemCurrencySettings(param);
      } else {
        request = this.$api.systemManagement.addSystemCurrencySettings(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.currencySettingsDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
